'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Instagram, Mail, Phone } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

export function SiteFooter() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const res = await fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })

      const data = await res.json()

      if (!res.ok) {
        toast.error(data.error || 'Error al suscribirse')
      } else {
        toast.success(data.message)
        setEmail('')
      }
    } catch (error) {
      toast.error('Error de red')
    } finally {
      setLoading(false)
    }
  }

  return (
    <footer className='bg-kuma-verde text-white font-allround'>
      <div className='container px-6 py-24'>
        <div className='grid grid-cols-1 md:grid-cols-12 gap-12 items-start'>
          {/* LOGO */}
          <div className='md:col-span-3 flex justify-center md:justify-start'>
            <Image
              src='/images/logo-kuma-footer.png'
              alt='Kuma Montessori'
              width={200}
              height={200}
              className='object-contain w-[180px] md:w-[220px]'
            />
          </div>

          {/* MENÚ */}
          <div className='md:col-span-5'>
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-16 gap-y-4 text-center md:text-left text-[18px] leading-[150%]'>
              <div className='flex flex-col gap-4'>
                <Link href='/'>home</Link>
                <Link href='/productos'>tienda</Link>
                <Link href='/nosotros'>nosotros</Link>
                <Link href='/contacto'>contacto</Link>
              </div>

              <div className='flex flex-col gap-4'>
                <Link href='/catalogo-educadores'>kuma para educadores</Link>
                <Link href='/entorno'>entorno kuma</Link>
                <Link href='/notas-kuma'>notas kuma</Link>
                <Link href='/glosario-montessori'>glosario montessori</Link>
              </div>
            </div>
          </div>

          {/* REDES + LEGALES + NEWSLETTER */}
          <div className='md:col-span-4 text-center md:text-left'>
            <div className='flex flex-col gap-4 text-[18px] leading-[150%]'>
              <a
                href='https://www.instagram.com/kumamontessori/'
                target='_blank'
                rel='noopener noreferrer'
                className='inline-flex items-center justify-center md:justify-start gap-2 hover:opacity-80 transition-opacity'
              >
                <Instagram className='h-5 w-5' />
                kumamontessori
              </a>

              <a
                href='mailto:contacto@kumamontessori.com.ar'
                className='inline-flex items-center justify-center md:justify-start gap-2 hover:opacity-80 transition-opacity'
              >
                <Mail className='h-5 w-5' />
                contacto@kumamontessori.com.ar
              </a>

              <a
                href='tel:+5493416901763'
                className='inline-flex items-center justify-center md:justify-start gap-2 hover:opacity-80 transition-opacity'
              >
                <Phone className='h-5 w-5' />
                +54 9 341 690 1763
              </a>

              <Link href='/terminos-y-condiciones' className='hover:underline'>
                Términos y Condiciones
              </Link>

              <Link href='/politica-de-privacidad' className='hover:underline'>
                Política de Privacidad
              </Link>
            </div>

            {/* NEWSLETTER */}
            <div className='mt-10'>
              <h4 className='text-lg font-semibold mb-4 text-white'>
                Comunidad Kuma, suscribite al newsletter
              </h4>

              <form
                className='flex flex-col sm:flex-row gap-3'
                onSubmit={handleNewsletterSubmit}
              >
                <Input
                  type='email'
                  placeholder='Tu email'
                  className='bg-white text-black placeholder:text-gray-500'
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />

                <Button
                  type='submit'
                  className='bg-[#FFA474] hover:bg-[#e68d5f] text-white'
                  disabled={loading}
                >
                  {loading ? 'Enviando...' : 'Enviar'}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <section className='sr-only'>
        <p>
          Kuma Montessori es una tienda online de materiales y juguetes
          Montessori en Argentina.
        </p>
      </section>

      <div className='border-t border-white/30 text-center py-6 text-sm opacity-90'>
        © {new Date().getFullYear()} Kuma Montessori. Todos los derechos
        reservados.
      </div>
    </footer>
  )
}
